import { call, put, takeLatest, select } from 'redux-saga/effects'
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'

import {
  CHANGE_PASS_REQUESTING,
  CHANGE_PASS_SUCCESS,
  CHANGE_PASS_ERROR,
  CHANGE_PASS_POST_API,
} from './constants'

const getChangePassState = state => state.changePass;

function changePassRequestApi (formData) {
  return axiosApi().put(CHANGE_PASS_POST_API, 
    {
      current_password: formData.current_password,
      password: formData.password,
      password_confirmation: formData.password_confirmation,
    }
  )
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function* changePassRequestFlow ({payload}) {
  try {
    // call to our myaccountsRequestApi function with the client
    const {code, message} = yield call(changePassRequestApi, payload)
    let error = null

    switch (code){
      case 400:
        if (typeof message == 'string') {
          error = message
        } else {
          error = []
          for(const element in message) {
            if (message.hasOwnProperty(element)) {
              error.push(`${element  }: ${  message[element]}`)
            }
          }
        }
        
        yield put({ type: CHANGE_PASS_ERROR, error })
        break;
      case 401:
        yield put({ type: CHANGE_PASS_ERROR, error: message })
        break;
      default:
        yield put({ type: CHANGE_PASS_SUCCESS, message })
        break;
    }

  } catch (error) {
    yield put({ type: CHANGE_PASS_ERROR, error })
  }
}

function* changePassWatcher () {
  yield takeLatest(CHANGE_PASS_REQUESTING, changePassRequestFlow)
}

export default changePassWatcher;



// WEBPACK FOOTER //
// ./src/views/Pages/ChangePassword/sagas.js